export default __webpack_public_path__ + "static/media/QBT.d78693f0.svg";